module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Zoom minus-cf429490f113ba8a7dcd6c92baf6b3b2.svg";